import { getShopDetail, login, loadSettleType } from "@/models/commonModel";
import { jzbReqAcc, jzbFlag } from "@/models/jzbModel";
import router from "@/router";
import basicRouter, { clickShow } from "@/router/modules/basicRouter";

const state = {
  roles: [],
  token: ""
};

const mutations = {
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  CLEAR_ROLES: state => {
    state.roles = [];
  },
  RESET_TOKEN: state => {
    localStorage.clear();
    state.token = "";
  }
};

const actions = {
  async login({ commit, state, dispatch }, params) {
    clickShow(false, basicRouter);

    return new Promise(async (resolve, reject) => {
      let status = false;
      let res = await login(params).catch(err => {
        reject(err);
        status = true;
      });
      if (!status) {
        let data = await getShopDetail().catch(err => {
          reject(err);
        });
        localStorage.setItem("supplier_id", data.supplier_id);
        localStorage.setItem("shop_type", data.shop_type); // 店铺类型
        localStorage.setItem("need_scan", data.need_scan);
        localStorage.setItem("is_enable", data.is_enable);
        localStorage.setItem("close_status", data.close_status);
        localStorage.setItem("activeHeader", "basic");
        localStorage.setItem("syncStatus", data.plug_id); // 同步状态
        localStorage.setItem("is_jgj", data.is_jgj); // 紧固件
        localStorage.setItem("first_login", true); // 登录标识(用来判断是否展示店铺公告)
        // 是否参加618定金购标识
        if (data.is_deposit && data.is_deposit == 1) {
          localStorage.setItem("is_deposit", true);
        }

        await loadSettleType({
          supplierId: localStorage.getItem("supplier_id")
        })
          .then(res => {
            console.log(res, "909090");
            localStorage.setItem("is_r4gys", `${res === 1 ? "1" : "0"}`); // todo 争艳 r4切结算中心的供应商
          })
          .catch(err => {
            console.log(err);
            this.$message.error(err.message);
          });
        resolve(data);
      }
    });
  },
  async getRoles({ commit, state, dispatch }) {
    let roles = [];
    // shop 店铺公共路由（包括平台直返工厂）
    // pingtai 平台店铺路由
    // zhifa 直发店铺公共路由
    // factory 工厂店铺公共路由
    // jzb 见证宝功能开放的路由
    // jgj 紧固件功能开放的路由
    // todo: r4切结算中心的供应商
    // is618djg: 是否参加618定金购 - 2024-04-26新增
    let shopType = localStorage.getItem("shop_type");
    let isJgj = localStorage.getItem("is_jgj");
    let isR4gys = localStorage.getItem("is_r4gys");
    let isDeposit = localStorage.getItem("is_deposit");
    if (isJgj === "1") {
      if (shopType) {
        roles = ["shop"];
      }
      //紧固件
      roles.push("jgj");
    } else if (isR4gys === "1") {
      roles = ["r4gys"];
    } else {
      if (shopType) {
        roles = ["shop"];
      }
      if (shopType === "0") {
        roles.push("pingtai");
      }
      if (shopType === "1") {
        roles.push("zhifa");
      }
      if (shopType === "2") {
        roles.push("factory");
      }
    }
    // 是否参加 618定金购
    if (isDeposit) {
      roles.push("is_deposit");
    }
    commit("SET_ROLES", roles);
    // return roles
    return new Promise((resolve, reject) => {
      resolve(roles);
    });
  },
  resetToken({ commit }) {
    commit("RESET_TOKEN");
  },
  logout({ commit, state, dispatch }) {
    clickShow(false, basicRouter);
    localStorage.clear();
    commit("CLEAR_ROLES");
    dispatch("app/clearInterval", "", { root: true });
    dispatch("permission/clearRoute", "", { root: true });
    dispatch("platform/switchPlatformOrderMessageShow", false, { root: true });
    dispatch("platform/clearInterval", {}, { root: true });
    router.push("/login");
  },
  clearRoles({ commit, dispatch }) {
    localStorage.clear();
    commit("CLEAR_ROLES");
    dispatch("permission/clearRoute", "", { root: true });
  },
  avatarClick({ commit, dispatch }, roles) {
    return new Promise(async resolve => {
      clickShow(true, basicRouter);
      commit("SET_ROLES", roles);
      const accessRoutes = await dispatch("permission/generateRoutes", roles, {
        root: true
      });
      router.addRoutes(accessRoutes);
      resolve();
    });
  },
  changeRoles({ commit, dispatch }, roles) {
    return new Promise(async resolve => {
      const roles = await dispatch("getRoles");
      commit("SET_ROLES", roles);
      const accessRoutes = await dispatch("permission/generateRoutes", roles, {
        root: true
      });
      router.addRoutes(accessRoutes);
      resolve();
    });
  },
  async getJzbInfo({ commit, state, dispatch }) {
    let roles = [...state.roles];
    try {
      if (localStorage.getItem("shop_id")) {
        /*
          2021 11 04 更改接口 判断 该用户 是否开通见证宝
          原接口使用 获取账户信息判断 /bindAcct/queryByShopId
          新接口 'shop-witness-status'  出参 pri 对私（个人）0 - 关闭 1 - 开启 pub 对公（企业）0 - 关闭 1 - 开启
        */
        let res = await jzbFlag({
          shopId: parseInt(localStorage.getItem("shop_id"))
        });
        if (res.code === 200) {
          let result = res.data;
          /*
            jzb_attribute 见正宝账户属性
            private 开通了对私的账号
            public 开通了对公的账号
            private-public 对公 对私 账号都开通了
            no 未开通
          */
          let jzb_attribute = "private-public";
          if (result.pri === 1 && result.pub === 0) {
            jzb_attribute = "private";
          } else if (result.pri === 0 && result.pub === 1) {
            jzb_attribute = "public";
          } else if (result.pri === 1 && result.pub === 1) {
            jzb_attribute = "private-public";
          } else {
            jzb_attribute = "no";
          }
          localStorage.setItem("jzb_attribute", jzb_attribute);
          /*
            紧固件 不显示 账户设置 菜单
            显示账户设置模块的逻辑判断
            账户不是紧固件 并且该账户 开通了见正宝账户 对公 对私 中至少一个账户
            jzb_attribute && jzb_attribute !== 'no' &&
          */
          if (
            jzb_attribute &&
            jzb_attribute !== "no" &&
            localStorage.getItem("is_jgj") !== "1"
          ) {
            roles.push("jzb");
            console.log(roles, "jzb");
          }
        }
      }
    } catch (error) {}
    commit("SET_ROLES", roles);
    dispatch("permission/jzbGenerateRoutes", roles, { root: true });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js